<template>
	<div class="upLeft ">
		<div class="itemTitleBox disStart">
			<span class="title">首页入口图片</span>
		</div>
		<div class="listBox disCenter">
			<div class="picBox disStart">
				<div class="picL boxShaw disCenter">
					<div v-if="obj.imgobj2.pictureUrl" class="imgBox">
						<img :src="$basImgUrl+obj.imgobj2.pictureUrl" class="avatar">
						<span class="delIcon" @click.stop="delImg(obj.imgobj2,2)"></span>
					</div>
					<el-upload v-else class="itemBox avatar-uploader disCenter" :data="{pictureType: 2,pictureIndex: 1}"
						:headers="headers" :action="$upUrl+'/projectAdvertisement/addProjectAdvertisement'"
						:show-file-list="false" :on-success="handleAvatarSuccess2">
						+商城入口
					</el-upload>
				</div>
				<div class="picR">
					<div class="picT boxShaw disCenter">
						<div v-if="obj.imgobj3.pictureUrl" class="imgBox">
							<img :src="$basImgUrl+obj.imgobj3.pictureUrl" class="avatar">
							<span class="delIcon" @click.stop="delImg(obj.imgobj3,3)"></span>
						</div>
						<el-upload v-else class="itemBox avatar-uploader disCenter" :data="{pictureType: 3,pictureIndex: 1}"
							:headers="headers" :action="$upUrl+'/projectAdvertisement/addProjectAdvertisement'"
							:show-file-list="false" :on-success="handleAvatarSuccess3">
							+充值入口
						</el-upload>
					</div>
					<div class="picB boxShaw disCenter">
						<div v-if="obj.imgobj4.pictureUrl" class="imgBox">
							<img :src="$basImgUrl+obj.imgobj4.pictureUrl" class="avatar">
							<span class="delIcon" @click.stop="delImg(obj.imgobj4,4)"></span>
						</div>
						<el-upload v-else class="itemBox avatar-uploader disCenter" :data="{pictureType: 4,pictureIndex: 1}"
							:headers="headers" :action="$upUrl+'/projectAdvertisement/addProjectAdvertisement'"
							:show-file-list="false" :on-success="handleAvatarSuccess4">
							+广告入口
						</el-upload>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>
//原:action="$upUrl+'/projectAdvertisement/addProjectAdvertisement'"地址
<script type="text/javascript">
	import ajax,{upLoadimg} from '../../../../../common/js/ajax.js'
	var token = localStorage.getItem('token')
	export default {
		name: "upLeft",
		data() {
			return {
				headers: {
					Authorization: token,
					token: token
				},
				url:upLoadimg,
				obj: {
					imgobj2: {
						advertisementId: "",
						pictureIndex: 1,
						pictureUrl: ""
					},
					imgobj3: {
						advertisementId: "",
						pictureIndex: 1,
						pictureUrl: ""
					},
					imgobj4: {
						advertisementId: "",
						pictureIndex: 1,
						pictureUrl: ""
					}
				},
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getlistProjectAdvertisementByPictureType(2)
				this.getlistProjectAdvertisementByPictureType(3)
				this.getlistProjectAdvertisementByPictureType(4)
			})
		},
		methods: {
			delImg(item, n) {
				this.$api.deleteProjectAdvertisement({
					advertisementId: item.advertisementId
				}).then((res) => {
					if (res.returnCode == 200) {
						if (n == 2) {
							this.$set(this.obj, "imgobj2", {
								advertisementId: "",
								pictureIndex: 1,
								pictureUrl: ""
							})
						}else if (n == 3) {
							this.$set(this.obj, "imgobj3", {
								advertisementId: "",
								pictureIndex: 1,
								pictureUrl: ""
							})
						}else if (n == 4) {
							this.$set(this.obj, "imgobj4", {
								advertisementId: "",
								pictureIndex: 1,
								pictureUrl: ""
							})
						}
					}
				})
			},
			getData() {},
			// banner上传成功后
			handleAvatarSuccess2(res, file, fileList) {
				this.getlistProjectAdvertisementByPictureType(2)
			},
			handleAvatarSuccess3(res, file, fileList) {
				this.getlistProjectAdvertisementByPictureType(3)
			},
			handleAvatarSuccess4(res, file, fileList) {
				this.getlistProjectAdvertisementByPictureType(4)
			},
			// 获取首页banner图
			getlistProjectAdvertisementByPictureType(n) {
				this.$api.listProjectAdvertisementByPictureType({
					pictureType: n
				}).then((res) => {
					if (res.returnCode == 200) {
						if (n == 2) {
							this.$set(this.obj, "imgobj2", res.obj[0] || {})
						}else if (n == 3) {
							this.$set(this.obj, "imgobj3", res.obj[0] || {})
						}else if (n == 4) {
							this.$set(this.obj, "imgobj4", res.obj[0] || {})
						}
						
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./upLeft.scss";
</style>
